import React, {useCallback} from 'react';
import CardActions from "../../../components/CardActions";
import {Button, Grid} from "@mui/material";
import {SectionBox} from '../../../components/FieldView';
import {useForm} from "react-hook-form";
import {OperacionTransferenciaTercerosFinalizar, schemaOperacionTransferenciaTercerosFinalizar} from "../types/dto";
import {zodResolver} from "@hookform/resolvers/zod/dist/zod";
import {
  OperacionTransferenciasTercerosChequeosComplianceFields,
  OperacionTransferenciaTercerosFields
} from "../types/fields";
import {HttpTransferenciaTerceros} from "../api/httpTransferenciaTerceros";
import {OperacionTransferenciaTerceros} from "../types/types";
import toast from "react-hot-toast";
import {useNavigate} from "react-router-dom";
import {useLoader} from "../../../../../hooks/useLoader";
import {ControlledTextField} from "../../../../../components/forms";
import {EntityWithIdFields} from "src/lib/itaptec/http_client/src";

interface SeccionTransferenciaTercerosFinalizarProps {
  operacion: OperacionTransferenciaTerceros,
  expandir?: boolean,
  permiteEditar?: boolean,
}

function SeccionTransferenciaTercerosFinalizar({
                                                 operacion,
                                                 expandir,
                                                 permiteEditar
                                               }: SeccionTransferenciaTercerosFinalizarProps) {
  const {showLoader, hideLoader} = useLoader()
  const navigation = useNavigate()

  const {
    control,
    handleSubmit,
    setValue,
    reset,
    resetField,
    formState: {errors}
  } = useForm<OperacionTransferenciaTercerosFinalizar>({
      resolver: zodResolver(schemaOperacionTransferenciaTercerosFinalizar),
      defaultValues: {
        [OperacionTransferenciaTercerosFields.NroOperacion]: operacion?.[OperacionTransferenciaTercerosFields.NroOperacion] ?? undefined,
        [OperacionTransferenciasTercerosChequeosComplianceFields.IdOperacionTransferenciasTerceros]: operacion[EntityWithIdFields.Id],
      }
    }
  )

  const alfinalizarOperacion = useCallback((data: OperacionTransferenciaTercerosFinalizar) => {
    showLoader();
    const promise = HttpTransferenciaTerceros.finalizarOperacion(data)

    toast.promise(promise, {
      loading: 'Guardando',
      success: 'Guardado correctamente.',
      error: 'Error al guardar.'
    })
      .then(() => navigation('/'))
      .catch(hideLoader)
  }, [operacion]);

  return (
    <CardActions title={'Finalizar Operación'} icon='mdi:check-circle-outline' colapsable collapsed={expandir}>
      <SectionBox>
        <Grid item xs={12} md={4}>
          <ControlledTextField
            control={control}
            name={OperacionTransferenciaTercerosFields.NroOperacion}
            label={'Nro Operación'}
            disabled={!permiteEditar}
            fullWidth
          />
        </Grid>
        {permiteEditar && (
          <Grid item xs={12} container justifyContent='flex-end'>
            <Button variant='contained' color='primary' onClick={handleSubmit(alfinalizarOperacion)}>
              Finalizar y notificar
            </Button>
          </Grid>
        )}
      </SectionBox>
    </CardActions>
  );
}

export default SeccionTransferenciaTercerosFinalizar;